import validate from "/app/node_modules/.pnpm/nuxt@3.16.0_@parcel+watcher@2.5.1_@types+node@22.13.10_db0@0.3.1_eslint@9.22.0_jiti@2.4_89302ae541b3279a246e13b68f4aa874/node_modules/nuxt/dist/pages/runtime/validate.js";
import authenticated_45global from "/app/middleware/authenticated.global.ts";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.16.0_@parcel+watcher@2.5.1_@types+node@22.13.10_db0@0.3.1_eslint@9.22.0_jiti@2.4_89302ae541b3279a246e13b68f4aa874/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  authenticated_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}